import { useFormContext } from "react-hook-form";
import { PwdReqType } from "../../types/Login";
import Input from "../../components/core/Input";
import { IconMail, IconRefresh } from "@tabler/icons-react";
import { ErrorMessage } from "@hookform/error-message";
import { useSubmitState } from "../../hooks/useSubmitState";
import {
  fetchCreatePasswordReset,
  getChallenge,
} from "../../fetch/fetch.authentication";
import { useNavigate } from "react-router-dom";
import { AUTH_STATE, ROUTE_AUTH } from "../../const/routes";
import { FormEvent } from "react";
import { EMAIL_VALIDATOR } from "../../const/validators.ts";
import { TEXT_EMAIL_REQUIRED } from "../../const/text.ts";
import ErrorButton from "../../types/Error/ErrorIcons.tsx";
import { solveChallenge } from "../../utils/challenge.ts";
import ErrorMap from "../../types/Error/ErrorIcons.tsx";

const initButton = (
  <>
    <IconRefresh />
    Passwort zurücksetzen
  </>
);

const submitSuccess = (
  <>
    <IconMail /> Mail gesendet. Klicke um fortzufahren.
  </>
);

const RequestReset = () => {
  const submitState = useSubmitState({
    initButtonChild: initButton,
  });
  const {
    register,
    getValues,
    formState: { errors, touchedFields },
  } = useFormContext<PwdReqType>();

  const navigate = useNavigate();

  const sendEmail = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (submitState.submitted) {
      return navigate(ROUTE_AUTH(AUTH_STATE.otp));
    }
    submitState.init();
    const challenge = await getChallenge();
    if (!challenge.ok) {
      submitState.fetchFailed(
        challenge.error,
        <ErrorMap error={challenge.error} />,
      );
      return;
    }
    const challengeSolved = await solveChallenge(
      challenge.value.challenge,
      challenge.value.difficulty,
    );
    const email = getValues("email");
    const res = await fetchCreatePasswordReset(
      email,
      challenge.value.challenge,
      challengeSolved,
    );
    if (!res.ok) {
      submitState.fetchFailed(res.error, <ErrorButton error={res.error} />);
      return;
    }
    submitState.fetchSuccess(submitSuccess);
  };

  return (
    <section className="grid rounded-box bg-base-200 p-3 gap-5">
      <div className="grid p-4 gap-4">
        <h2 className="text-2xl font-bold">Passwort zurücksetzen</h2>
        <form onSubmit={sendEmail}>
          <Input
            input="input"
            validatorHint={<ErrorMessage errors={errors} name="email" />}
            icon={<IconMail />}
            label={"Email"}
            isTouched={!!touchedFields.email}
            isError={!!errors.email}
          >
            <input
              type="email"
              autoComplete="email"
              placeholder={`Gib deine Account Email an`}
              {...register("email", {
                required: TEXT_EMAIL_REQUIRED,
                validate: EMAIL_VALIDATOR,
              })}
            />
          </Input>
          {submitState.submitted ? (
            <button className={`btn btn-success w-full`}>
              {submitState.buttonChild}
            </button>
          ) : (
            <button
              className={`btn w-full ${errors.email ? "btn-disabled" : "btn-accent"}`}
            >
              {submitState.buttonChild}
            </button>
          )}
        </form>
      </div>
    </section>
  );
};
export default RequestReset;
